import request from 'superagent';
import Model from '../model';
import * as actions from './actions'

class Feedback extends Model {
    read() {
        const selectorFunction = (state, systemType) => {
            return {
                'feedback': state.getIn(['feedback', systemType])
            }
        }
        const dispatchFunction = (systemType, index) => {

            const url = this.url()
            const token = this.token()
            const offset = index-1; //Offset starts from 0 in backend and we use pages (starts from 1) here

            return (dispatch) => {
                request
                .post(`${url}/v2/feedback/get`)
                .send({
                    'system_type': systemType,
                    'offset': offset
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.setHelpDeskFeedback(res.body))
                    }
                })
            }
        }
        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }

    readById(systemType, systemId, cb) {
        const url = this.url()
        const token = this.token()

        return request
            .post(`${url}/v2/feedback/id/get`)
            .send({
                'system_type': systemType,
                'system_id': systemId
            })
            .set('Authorization', `Bearer ${token}`)
            .accept('application/json')
            .set('Content-Type', 'application/json')
            .end((err, res) => {
                if (res.statusCode === 200) {
                    cb(res.body)
                }
            })
    }

    readQuestions(systemType, sortingKey, offset=0, cb) {
        const selectorFunction = (state, systemType) => {
            return state.getIn(['feedback', systemType])
        }

        const dispatchFunction = (systemType, sortingKey, index) => {
            const url = this.url()
            const token = this.token()
            const offset = index-1; //Offset starts from 0 in backend and we use pages (starts from 1) here

            return (dispatch) => {
                request
                .post(`${url}/v2/feedback/questions/read`)
                .send({
                    'system_type': systemType,
                    'offset': offset,
                    'sorting_key': sortingKey
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.setHelpDeskFeedbackQuestions(res.body))
                    }
                })
            }
        }
        return {
            selector: selectorFunction, dispatcher : dispatchFunction
        }
    }

    getUnread(systemType, callback) {

        const dispatchFunction = (systemType, callback) => {
            const url = this.url()
            const token = this.token()

            return (dispatch) => {
                request
                .post(`${url}/v2/feedback/unread/get`)
                .send({
                    'system_type': systemType,
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        callback(res.body.unread);
                    }
                })
            }
        }
        return {
            dispatcher : dispatchFunction
        }
    }

    setCurrentItem(currentItem) {
        return (dispatch) => {
            dispatch(actions.setFeedbackCurrentItem(currentItem))
        }
    }
}
export default new Feedback();



// WEBPACK FOOTER //
// ./src/model/Feedback/model.js